/**
 * Подписывается на публичный канал новых оповещений, обновляет фид оповещений на главной
 */

const subscriber = (rt) => {
  rt.subscribePublic("discussions", data => {
    console.log('e', data)
    if (data.conversation) { 
      let feed = document.querySelector('.conversations-list');
      if (feed) {
        feed.insertAdjacentHTML('afterbegin', data.conversation);
      }
    }
  });
};

export default subscriber;